/* tslint:disable */
/* eslint-disable */
/**
 * Web IMD-CONNECT.PRO
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface PaymentReceipt
 */
export interface PaymentReceipt {
    /**
     * 
     * @type {number}
     * @memberof PaymentReceipt
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof PaymentReceipt
     */
    'gross'?: number;
    /**
     * 
     * @type {number}
     * @memberof PaymentReceipt
     */
    'date'?: number;
    /**
     * 
     * @type {string}
     * @memberof PaymentReceipt
     */
    'payer'?: PaymentReceiptPayerEnum;
    /**
     * 
     * @type {string}
     * @memberof PaymentReceipt
     */
    'type'?: PaymentReceiptTypeEnum;
}

export const PaymentReceiptPayerEnum = {
    Kunde: 'kunde',
    Versicherung: 'versicherung',
    Anwalt: 'anwalt'
} as const;

export type PaymentReceiptPayerEnum = typeof PaymentReceiptPayerEnum[keyof typeof PaymentReceiptPayerEnum];
export const PaymentReceiptTypeEnum = {
    Brutto: 'brutto',
    Netto: 'netto',
    Mehrwertsteuer: 'mehrwertsteuer',
    Refund: 'refund'
} as const;

export type PaymentReceiptTypeEnum = typeof PaymentReceiptTypeEnum[keyof typeof PaymentReceiptTypeEnum];


